import { Text, idea, setScoreColor } from './common'
import React from 'react';

/** @atom Title: */
const Title = ({ name }: { name: string }) => <Text content={name} isTitle color={'info'}/>

/** @atom Pitch: */
const Pitch = ({ pitch }: { pitch: string }) => <Text content={pitch} size={6}/>

/** @atom Views: */
const Views = ({ views }: { views: number }) => <Text content={views}/>

/** @atom Score: */
const Score = ({ score }: { score: number }) => {
    const text = <> <span style={{color:'#444'}}> Score: </span> { score } </>
    return <Text content = { text } color = { setScoreColor(score) } alignment = { 'right' }/>
}

/** @molecule IdeaCard: */
interface iIdeaCard {
    idea: idea;
    onClick(idea:idea):void;
}

const Card = ({ idea, onClick }: iIdeaCard) => <div 
    className="box" 
    style={{cursor:'pointer'}}
    onClick={() => onClick(idea)}
>
    <Title name={ idea.name } />
    <Pitch pitch={ idea.pitch } />
    { idea.views ? <Views views={ idea.views } /> : null }
    <Score score={ idea.score || 0 } />
</div>


/** @organism IdeasGrid: */
interface iIdeasGrid {
    ideas: idea[];
    onClick(idea: idea): void;
}

export const IdeasGrid = ({ideas, onClick}: iIdeasGrid) => {

    const addRow = (d: idea[][], i: idea) => [...d, [i]]
    const extendRow = (d: idea[][], i: idea) => d.map((j, jdx, l) => 
        l.length === (jdx + 1) ? [...j, i]: j
    )

    const IdeaRows = () => ideas.reduce((d:idea[][], i: idea, idx: number) => 
        idx % 3 ? extendRow(d, i) : addRow(d, i), [] as idea[][]
    )

    return <div className="container">
        { 
            IdeaRows().map((row: idea[], k:number) => 
                <div className="columns" key={k}>
                    {
                        row.map((idea: idea, key: number) => 
                            <div className="column is-one-third" key={key}>
                                <Card idea={idea} onClick={onClick}/>
                            </div>
                        )
                    }
                </div>
            )
        }
    </div>
} 
